
























import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model } from "../login-controlador";

import usuario from './login-recuperar-usuario.vue';
import email from './login-recuperar-email.vue';
import codigo from './login-recuperar-codigo.vue';
import password from './login-recuperar-password.vue';
import error from './login-recuperar-error.vue';
import ok from './login-recuperar-ok.vue';
@Component( {
    name: "Componente",
    props: {},
    components: {
        usuario,
        email,
        codigo,
        password,
        error,
        ok,
    }
} )
export default class Componente extends Vue
{
    get Controlador() { return Model.Recuperar; }
    get UsuarioActual() { return Model.Recuperar.UsuarioActual; }

    Listo: boolean = false;
    Modo: 'email' | 'codigo' | 'usuario' | 'password' | 'error' | 'ok' = 'usuario';
    async mounted()
    {
        this.Controlador.$on( 'modo', () =>
        {
            this.Modo = this.Controlador.Modo;
        } );
        this.Listo = true;
    }

}
